 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		38: 0,
 		0: 0,
 		1: 0,
 		2: 0,
 		3: 0,
 		4: 0,
 		10: 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"4":"vendors~BulkRoster~ContentAccessLookup~MergeApproval~MergeRequest~OneRosterOrgs~ProvisionSchools~Pygmalion","6":"MergeApproval~MergeRequest~UserDash","7":"News","8":"Bulk-Processing-Status","9":"MergeApproval~MergeRequest","11":"AssignmentContainer","12":"AssignmentsContainer","13":"BulkRoster","14":"ContentAccessLookup","15":"District-Report","16":"Home","17":"LazyAssignedArticleReviewContainer","18":"LazyCanvasAssignmentReviewContainer","19":"LazySearchComponent","20":"LessonSparkContainer","21":"MergeApproval","22":"MergeRequest","23":"OneRosterOrgs","24":"OpenMergeRequests","25":"ProvisionSchools","26":"Pygmalion","27":"ReadContainer","28":"StandaloneExternalEmbed","29":"StandalonePoll","30":"StandardContainer","31":"TeacherBinder","32":"TextSets","33":"UnitsContainer","34":"UserDash","35":"YourContentContainer","37":"browse","40":"vendors~ProvisionSchools","41":"vendors~browse"}[chunkId]||chunkId) + "." + {"0":"0686ff2e78ccc36deef2","1":"8368965eb47f8105cfa0","2":"a913211632ae4191f8ab","3":"706a48cb334a8ba858af","4":"ef7eeedebc9741e31717","5":"0108522ec0440165b007","6":"ddca838830133e733f41","7":"7dacc5671c5aa66457ca","8":"1884d740da542ab76c24","9":"abe33fc82a5054288e13","10":"65370682e7390d759d5c","11":"cbbd6ec622e4074b88ce","12":"e56054dd191ed5bcd979","13":"d5faa1b37eddbadd7fbf","14":"25dd3a206e8b099f3315","15":"0ff891d89ab4d74d1c1e","16":"6a790b0967389fa4c881","17":"8fc86f73022f1a90f198","18":"74954e8bb7df51a00530","19":"404a13aaf0540ffce6e4","20":"744ac194f85f1c74c06b","21":"a74db74c6c45514c0edb","22":"ce079eb64c3b9b5ed395","23":"a22147c9ceb38b03f01a","24":"8b3e5bce3593277c6a10","25":"e5f18d6d600eaf5cf631","26":"3ca4f5f0f0ebbf4a8ea3","27":"73943f96a659d5e15859","28":"273d89f81e6907255080","29":"fa49b35ef01ea3658def","30":"a4d712901cc66110d4d1","31":"40e7c8498911b7360069","32":"a18fd709e72fab9279fd","33":"1605411e8f8bc995e36d","34":"7d0f4ce6f7aab33413d4","35":"7593779260765f89cb74","37":"7f9b4c12b1b83e325eb9","40":"01f3e0653639a75f93a4","41":"fbfff23bfed65bb4121e","42":"f380672fa4d22577d87f","43":"607d6fdfcd61b851a9ec","44":"beb8e26f1aa7a61af908","45":"3c8413cfb270b3af6905","46":"6d37b44e3f1994228701","47":"3f6bbd371364d56f6e3b","48":"32f0aa3d60522c0402f5","49":"d7033e500ff231ce8d00","50":"d866c4e0f69dcd4efa34","51":"875a09cb9be9e4b5a3bb","52":"8111a96805d5ea03cf6c"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 1609);
